import {
  BLOG_NEWS,
  BLOG_NUTRITION,
  BLOG_SKINCARE,
  BLOG_STUDIES,
  PODCASTS,
} from 'lib/constants/routes';

export const BLOG_CATEGORIES = {
  NEWS: {
    ID: 'news',
    ROUTE: BLOG_NEWS,
    FORMAT: 'News',
  },
  NUTRITION: {
    ID: 'nutrition',
    ROUTE: BLOG_NUTRITION,
    FORMAT: 'Nutrition',
  },
  SKINCARE: {
    ID: 'skincare',
    ROUTE: BLOG_SKINCARE,
    FORMAT: 'Skincare',
  },
  STUDIES: {
    ID: 'studies',
    ROUTE: BLOG_STUDIES,
    FORMAT: 'Studies',
  },
  PODCASTS: {
    ID: 'podcasts',
    ROUTE: PODCASTS,
    FORMAT: 'Podcasts',
  },
} as const;

export type BlogCategoriesType =
  | 'news'
  | 'nutrition'
  | 'skincare'
  | 'studies'
  | 'podcasts';
